import { useCallback, useEffect, useRef, useState } from 'react';
import { message } from 'antd';
import { exportDownloadUrl, exportTaskStatus } from '../api/finance';
import { downloadExcel } from '../util/download';

/**
 * 异步导出：提交任务 → 轮询状态 → 用户点击下载。
 */
export default function useExportTask() {
  const [visible, setVisible] = useState(false);
  const [task, setTask] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const timer = useRef(null);

  const stopPolling = useCallback(() => {
    if (timer.current) {
      clearInterval(timer.current);
      timer.current = null;
    }
  }, []);

  useEffect(() => stopPolling, [stopPolling]);

  const poll = useCallback(
    (taskNo) => {
      stopPolling();
      timer.current = setInterval(async () => {
        try {
          const res = await exportTaskStatus(taskNo);
          setTask(res);
          if (res?.status === 2 || res?.status === 3) {
            stopPolling();
            if (res.status === 3) {
              message.error(res.errorMsg || '导出失败');
            }
          }
        } catch (error) {
          stopPolling();
          message.error(error?.message || '查询导出状态失败');
        }
      }, 1500);
    },
    [stopPolling]
  );

  const start = useCallback(
    async (exportApi, query) => {
      setSubmitting(true);
      try {
        const taskNo = await exportApi(query);
        setTask({ taskNo, status: 0, progress: 0 });
        setVisible(true);
        poll(taskNo);
      } catch (error) {
        message.error(error?.message || '提交导出任务失败');
      } finally {
        setSubmitting(false);
      }
    },
    [poll]
  );

  const close = () => {
    stopPolling();
    setVisible(false);
    setTask(null);
  };

  const download = async () => {
    if (!task?.taskNo) return;
    try {
      await downloadExcel(exportDownloadUrl(task.taskNo), task.fileName || '导出数据.xlsx');
    } catch (error) {
      message.error('下载失败，请稍后重试');
    }
  };

  return { visible, task, submitting, start, close, download };
}
